import { CartItems } from '@/hooks/CartContext';
import { ComboCartItemAllocation, getComboDiscountParticipatingQuantityForCartItem } from './comboCartUtils';

interface ComboFlexPortion {
    comboPortion?: 'combo' | 'excess';
    comboDiscountQuantity?: number;
}

/**
 * Porção com combo ATIVO (kit completo dentro do max_combo): recebe o desconto de combo e não
 * acumula flex. Kit em andamento (comboDiscountQuantity === 0) e excedente (comboPortion==='excess')
 * ficam de fora e aplicam flex normalmente. O flex persistido da porção não é apagado — só deixa de
 * ser lido enquanto isto for true; volta a valer sozinho se o combo desativar.
 */
export const isActiveComboPortion = (portion: ComboFlexPortion | null | undefined): boolean =>
    portion?.comboPortion === 'combo' && (portion?.comboDiscountQuantity ?? 0) > 0;

/**
 * Mesma regra a partir das alocações de UMA instância — para checkout/payload, que já recebem
 * `allocations` pré-filtradas por `comboInstanceId` e não têm a "fatia" de exibição em mãos.
 */
export const isActiveComboPortionFromAllocations = (
    item: Pick<CartItems, 'uid' | 'sku' | 'option_uid' | 'quantity'>,
    allocations: ComboCartItemAllocation[] | undefined
): boolean =>
    isActiveComboPortion({
        comboPortion: 'combo',
        comboDiscountQuantity: getComboDiscountParticipatingQuantityForCartItem(item, allocations),
    });

/** Percentual de flex efetivo desta porção: 0 quando bloqueado por combo ativo. */
export const resolveEffectiveFlexPercent = (
    percent: number | null | undefined,
    portion: ComboFlexPortion | null | undefined
): number => (isActiveComboPortion(portion) ? 0 : Number(percent) || 0);
